import { createSelector } from 'reselect'
import { getOrNull } from '../../utils/selectors'
import { createEntitiesSelector } from '../../utils/normalize'

import { selectLoginTokenData } from '../Login/selectors'
import { userSchemas } from './schema'

export const selectCurrenUserId = createSelector(
  selectLoginTokenData,
  getOrNull('id')
)

export const selectCurrentUserProfile = createEntitiesSelector(
  selectCurrenUserId,
  userSchemas.denormalize
)
